import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  HelpCircle,
  MoreVertical,
  X,
  User,
  LogOut,
  LogIn,
  ShoppingCart,
  MessageCircle,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { headerStyles } from "./headerStyles";

const Header = ({
  isSidebarOpen,
  isRightSidebarOpen,
  toggleSidebar,
  toggleRightSidebar,
  cartCount,
  toggleMyShop,
  showMyShop,
  setShowAccessModal,
  selectedCategory,
  setSelectedCategory,
}) => {
  const navigate = useNavigate();
  const styles = headerStyles;

  const [showLogoutMenu, setShowLogoutMenu] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [credentials, setCredentials] = useState({ userID: "", password: "" });
  const [loginError, setLoginError] = useState("");
  const [unreadCount, setUnreadCount] = useState(0);

  const userStr = localStorage.getItem("erpUser");
  const user = userStr ? JSON.parse(userStr) : null;

 console.log("erpUser from LS:", user); // ← put it here

  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const isAdmin = user?.level === "admin";

  // Clean userId for display & fetch
  const userId = (user?.userid || user?.id || "").trim();

  const categories = [
    "Grocery", "Makanan", "Perabotan", "Rumah", "Kendaraan",
    "Komputer", "Elektronik", "Fashion", "Lain2",
  ];

  // Fetch unread message count (polling every 30s)
  useEffect(() => {
    if (!isLoggedIn) {
      setUnreadCount(0);
      return;
    }

    const userId = (user?.userid || "").toString().trim(); // "andi"
    if (!userId) return;

    const fetchUnread = async () => {
      try {
        const res = await axios.get(
          `https://api.kamulyaan.id/msg/unread-count?user_id=${userId}`
        );
        console.log("Unread count response:", res.data); // ← debug log
        setUnreadCount(res.data.count ?? 0);
      } catch (err) {
        console.error("Failed to fetch unread count:", err);
        setUnreadCount(0);
      }
    };

    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);

    return () => clearInterval(interval);
  }, [isLoggedIn, userId]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError("");

    try {
      const res = await fetch("https://api.kamulyaan.id/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userid: credentials.userID,
          password: credentials.password,
        }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        setLoginError(data.message || "Login gagal");
        return;
      }

      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("erpUser", JSON.stringify(data.user));
      window.location.reload();
    } catch {
      setLoginError("Tidak dapat terhubung ke server");
    }
  };

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };
  

  return (
    <>
      {/* LEFT SIDEBAR – Categories */}
      {isSidebarOpen && (
        <div style={styles.sidebarOverlay}>
          <div style={styles.sidebar}>
            <div style={styles.sidebarHeader}>
              <X onClick={toggleSidebar} style={styles.closeIcon} />
            </div>
            <ul style={styles.sidebarMenu}>
              <li
                style={{
                  ...styles.sidebarMenuItem,
                  color: selectedCategory === "Semua" ? "#6bbe23" : "#fff",
                  fontWeight: selectedCategory === "Semua" ? "bold" : "normal",
                }}
                onClick={() => {
                  setSelectedCategory("Semua");
                  toggleSidebar();
                }}
              >
                Semua
              </li>
              {categories.map((cat) => (
                <li
                  key={cat}
                  style={{
                    ...styles.sidebarMenuItem,
                    color: selectedCategory === cat ? "#6bbe23" : "#fff",
                    fontWeight: selectedCategory === cat ? "bold" : "normal",
                  }}
                  onClick={() => {
                    setSelectedCategory(cat);
                    toggleSidebar();
                  }}
                >
                  {cat}
                </li>
              ))}
            </ul>
          </div>
          <div style={styles.overlayBackdrop} onClick={toggleSidebar} />
        </div>
      )}

      {/* RIGHT SIDEBAR – My Shop / Admin / Sales / Buying / Messages */}
{/* RIGHT SIDEBAR – My Shop / Admin / Sales / Buying / Messages */}
{isRightSidebarOpen && (
  <div style={styles.sidebarOverlay}>
    <div
      style={{
        ...styles.rightSidebar,
        // FIXED: Slide from RIGHT
        right: 0,
        left: "auto",
        transform: isRightSidebarOpen ? "translateX(0)" : "translateX(100%)",
        position: "fixed",
        top: 0,
        height: "100vh",
        zIndex: 2000,
      }}
    >
      <div style={styles.sidebarHeader}>
        <X onClick={toggleRightSidebar} style={styles.closeIcon} />
      </div>
      <ul style={styles.sidebarMenu}>
        {isLoggedIn && (
          <>
            <li
              style={{
                ...styles.sidebarMenuItem,
                color: showMyShop ? "#FFA500" : "#fff",
                fontWeight: showMyShop ? "bold" : "normal",
              }}
              onClick={() => {
                toggleMyShop();
                toggleRightSidebar();
              }}
            >
              🏪 My Shop
            </li>

            {isAdmin && (
              <li
                style={styles.sidebarMenuItem}
                onClick={() => {
                  navigate("/admin");
                  toggleRightSidebar();
                }}
              >
                ⚙️ Admin Panel
              </li>
            )}

            <li
              style={styles.sidebarMenuItem}
              onClick={() => {
                navigate("/salespanel");
                toggleRightSidebar();
              }}
            >
              Panel Penjualan
            </li>

            <li
              style={styles.sidebarMenuItem}
              onClick={() => {
                navigate("/buyingpanel");
                toggleRightSidebar();
              }}
            >
              Panel Pembelian
            </li>

            <li
              style={styles.sidebarMenuItem}
              onClick={() => {
                navigate("/msg");
                toggleRightSidebar();
              }}
            >
              Pesan & Notifikasi
            </li>
          </>
        )}
      </ul>
    </div>
    <div style={styles.overlayBackdrop} onClick={toggleRightSidebar} />
  </div>
)}

      {/* LOGIN MODAL */}
      {showLoginModal && (
        <div style={localStyles.modalOverlay}>
          <div style={localStyles.modalContent}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ margin: 0 }}>Login Toko</h3>
              <X onClick={() => setShowLoginModal(false)} style={{ cursor: "pointer", color: "#555" }} />
            </div>

            <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "16px" }}>
              <input
                type="text"
                placeholder="UserID"
                value={credentials.userID}
                onChange={(e) => setCredentials({ ...credentials, userID: e.target.value })}
                required
                style={localStyles.input}
              />
              <input
                type="password"
                placeholder="Password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                required
                style={localStyles.input}
              />
              {loginError && <p style={{ color: "red", fontSize: "0.85rem", margin: "4px 0" }}>{loginError}</p>}
              <button type="submit" style={localStyles.loginBtn}>
                Masuk
              </button>
            </form>
          </div>
        </div>
      )}

      {/* MAIN HEADER + NAV */}
      <div style={styles.mainContent}>
        <header style={styles.header}>
          <div style={styles.headerLeft}>
            <h1 style={styles.title}>Toko Kamulyaan</h1>
          </div>
          <div style={styles.headerRight}>
            <HelpCircle style={styles.headerIcon} onClick={() => navigate("/help")} />
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <MessageCircle
                style={styles.headerIcon}
                onClick={() => {
                  if (!isLoggedIn) {
                    setShowAccessModal(true);
                  } else {
                    navigate("/msg");
                  }
                }}
              />
              {unreadCount > 0 && (
                <span style={{
                  ...localStyles.badge,
                  backgroundColor: "#e63946",
                }}>
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </div>
            <MoreVertical style={styles.headerIcon} onClick={toggleRightSidebar} />
          </div>
        </header>

        <nav style={{ ...styles.menuBar, justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={styles.hamburgerMenu} onClick={toggleSidebar}>
              <img src="/images/hamburger.png" alt="Menu" style={styles.hamburgerIcon} />
            </div>

            {isLoggedIn && (
              <div
                style={{ ...styles.menuItem, fontWeight: "bold", color: "#6bbe23" }}
                onClick={() => navigate("/add")}
              >
                +Baru
              </div>
            )}
          </div>

          <div style={{ position: "relative", paddingRight: "10px" }}>
            {isLoggedIn ? (
              <User style={{ cursor: "pointer" }} onClick={() => setShowLogoutMenu(!showLogoutMenu)} />
            ) : (
              <LogIn style={{ cursor: "pointer" }} onClick={() => setShowLoginModal(true)} />
            )}

            {/* Logout Dropdown – with UserID displayed above Keluar */}
            {showLogoutMenu && (
              <div style={localStyles.logoutDropdown}>
                {/* UserID info */}
                <div style={{
                  padding: "10px 16px",
                  background: "#f8fafc",
                  borderBottom: "1px solid #e2e8f0",
                  color: "#475569",
                  fontSize: "0.9rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }} onClick={() => setShowLogoutMenu(false)}>
                  <User size={16} />
                  <span>
                    <strong>.</strong> {userId || "User"}
                  </span>
                </div>

                {/* Keluar button */}
                <div
                  onClick={logout}
                  style={localStyles.dropdownItem}
                >
                  <LogOut size={16} /> Keluar
                </div>
              </div>
            )}
          </div>
        </nav>
      </div>
    </>
  );
};

const localStyles = {
  modalOverlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 5000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "12px",
    width: "320px",
    maxWidth: "90%",
  },
  input: {
    padding: "10px 12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  loginBtn: {
    padding: "12px",
    backgroundColor: "#6bbe23",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "1rem",
  },
  badge: {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    backgroundColor: "#e63946",
    color: "white",
    borderRadius: "50%",
    padding: "2px 6px",
    fontSize: "0.75rem",
    fontWeight: "bold",
    minWidth: "18px",
    textAlign: "center",
  },
  logoutDropdown: {
    position: "absolute",
    top: "36px",
    right: 0,
    backgroundColor: "white",
    boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
    zIndex: 3000,
    borderRadius: "6px",
    minWidth: "140px",
    overflow: "hidden",
  },
  dropdownItem: {
    padding: "10px 16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    color: "#333",
    fontSize: "0.95rem",
  },
};

export default Header;